import { Component, Input, Inject } from '@angular/core';

import {OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'rm-form-dialog',
  templateUrl: './form-dialog.component.html',
  styleUrls: ['./form-dialog.component.css']
})
export class FormDialogComponent implements OnInit {

    defaultTitle: string = 'Form Dialog';
    isFormValid: boolean = true;
    defaultSaveBtnTxt: string = "Save";
    formStatus: string = 'INVALID';

    constructor(
        private dialogRef: MatDialogRef<FormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData
    ) {
    }

    ngOnInit() {
    }

    cancel() {
        this.dialogRef.close();
    }

    close(fields) {
        var retData = {};
        fields.forEach(element => {
            retData[element.key] = element.value;
        });

        this.dialogRef.close(retData);
    }

    statusChanged(status) {
        this.formStatus = status;
    }
}

export interface DialogData {
    title: string;
    fields: any[];
    note: string;
    saveBtnTxt: string;
    titleBgColor: any;
    values: any;
}

  